/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRunImageDetectorRequestImageSourceFromJSON, StreemApiRunImageDetectorRequestImageSourceToJSON, } from './';
export function StreemApiRunImageDetectorRequestFromJSON(json) {
    return StreemApiRunImageDetectorRequestFromJSONTyped(json, false);
}
export function StreemApiRunImageDetectorRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'image': !exists(json, 'image') ? undefined : StreemApiRunImageDetectorRequestImageSourceFromJSON(json['image']),
        'callbackUrl': !exists(json, 'callback_url') ? undefined : json['callback_url'],
    };
}
export function StreemApiRunImageDetectorRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'image': StreemApiRunImageDetectorRequestImageSourceToJSON(value.image),
        'callback_url': value.callbackUrl,
    };
}
//# sourceMappingURL=StreemApiRunImageDetectorRequest.js.map